
<app-modal-title i18n>Collecting Log Packages</app-modal-title>
<app-modal-body>
    <div class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text ot-pt-1 ot-pb-1">
        <div class="ot-progress__outer">
            <div class="ot-progress__meter">
            </div>
        </div>
        <div class="ot-progress__text ot-pt-1">{{text}}</div>
    </div>
</app-modal-body>
<app-modal-footer>
    <button id="logs-package-exit-button" [disabled]="isCompleted" role="button" otsc-button color="primary" (click)="exit()" i18n>Exit</button>
</app-modal-footer>